import { BaseProductSerializer } from './BaseProductSerializer';

class SimpleProductSerializer {
  static deSerialize(data) {
    const baseProduct = BaseProductSerializer.deSerialize(data);
    const characteristicData = data.CaracteristicasArticulosTextoWeb || [];
    const chars = characteristicData.map(SimpleProductSerializer.deSerializeCharacteristics);
    let productType = null;
    let subMenu = null;
    const productTypeData = data.TiposDeArticulos || null;
    const subMenuData = productTypeData ? productTypeData.SubFamiliaArticulos : null;
    if (productTypeData && subMenuData) {
      productType = {
        id: productTypeData.TArID,
        name: productTypeData.TArNombre,
      };
      subMenu = {
        id: subMenuData.SFAID,
        name: subMenuData.SFANombre,
      };
    }
    return {
      ...baseProduct,
      characteristics: chars,
      productType,
      subMenu,
      serviceProduct: data.Instalacion
        ? SimpleProductSerializer.deSerialize(data.Instalacion)
        : null,
    };
  }

  static deSerializeCharacteristics(characteristic) {
    return {
      index: characteristic.CATOrden,
      text: characteristic.CATTexto,
    };
  }
}

export { SimpleProductSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/SimpleProductSerializer.js